/** Слой названий комнат: своё имя комнаты по её id («Кухня» вместо «ПО 3»). */
import { create } from "zustand";
import type { RoomName } from "@/shared/plan";

interface RoomNamesLayerState {
	items: Record<string, RoomName>;
	/** Пустое название убирает своё — комната снова подписана номером */
	setRoomName: (roomId: string, name: string) => void;
	restoreRoomNames: (items: Record<string, RoomName>) => void;
}

export const useRoomNamesStore = create<RoomNamesLayerState>((set) => ({
	items: {},
	setRoomName: (roomId, name) =>
		set((state) => {
			const trimmed = name.trim();
			if ((state.items[roomId]?.name ?? "") === trimmed) return state;
			const items = { ...state.items };
			if (trimmed === "") delete items[roomId];
			else items[roomId] = { id: roomId, roomId, name: trimmed };
			return { items };
		}),
	restoreRoomNames: (items) => set({ items }),
}));
